import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  /** Texto plano en la mayoria de pantallas; admite marcado cuando la ficha necesita iconos. */
  description: ReactNode;
  action?: ReactNode;
}

/** Cabecera comun de las pantallas administrativas. */
export function PageHeader({ title, description, action }: PageHeaderProps): ReactNode {
  return (
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h1 className="text-xl font-semibold text-content">{title}</h1>
        <p className="mt-1 text-sm text-muted">{description}</p>
      </div>
      {action}
    </header>
  );
}
